import { useEffect, useState } from "react";
import { Cake } from "lucide-react";
import { api } from "@/lib/api";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function AdminBirthdays() {
  const [list, setList] = useState([]);

  useEffect(() => { api.get("/admin/birthdays").then((r) => setList(r.data)); }, []);

  const upcoming = list.filter((b) => b.highlight);
  const rest = list.filter((b) => !b.highlight);

  return (
    <div data-testid="admin-birthdays">
      <div className="mb-8">
        <h1 className="font-serif text-3xl text-brand-soft">Birthday list</h1>
        <p className="text-sm text-brand-soft/60 mt-1">Sorted by next upcoming birthday. Highlights show pets celebrating in the next 7 days.</p>
      </div>

      {upcoming.length > 0 && (
        <div className="bg-brand-mustard/10 border border-brand-mustard/30 rounded-2xl p-6 mb-7" data-testid="upcoming-birthdays">
          <div className="font-serif text-xl text-brand-maroon flex items-center gap-2 mb-4"><Cake className="w-5 h-5" /> Next 7 days</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {upcoming.map((b) => <BirthdayRow key={b.booking_id} b={b} highlight />)}
          </div>
        </div>
      )}

      <div className="bg-white rounded-2xl border border-brand-maroon/10 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-brand-ivory text-brand-soft/70">
              <tr>
                <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Pet</th>
                <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Parent</th>
                <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Contact</th>
                <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Birthday</th>
                <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Days away</th>
              </tr>
            </thead>
            <tbody>
              {rest.length === 0 && upcoming.length === 0 && (
                <tr><td colSpan={5} className="p-8 text-center text-brand-soft/60 italic">No birthdays collected yet.</td></tr>
              )}
              {rest.map((b) => (
                <tr key={b.booking_id} className="border-t border-brand-maroon/5">
                  <td className="px-4 py-3">{b.pet_name || <span className="text-brand-soft/40">—</span>}</td>
                  <td className="px-4 py-3">{b.pet_parent_name}</td>
                  <td className="px-4 py-3 text-xs text-brand-soft/70">
                    <div>{b.email}</div>
                    <div>{b.whatsapp_number}</div>
                  </td>
                  <td className="px-4 py-3">{b.day} {MONTHS[b.month - 1]}</td>
                  <td className="px-4 py-3">{b.days_until_next}d</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const BirthdayRow = ({ b }) => (
  <div className="bg-white rounded-xl p-4 border border-brand-mustard/30">
    <div className="font-medium">{b.pet_name || "—"} <span className="text-xs text-brand-soft/60">· {b.day} {MONTHS[b.month - 1]}</span></div>
    <div className="text-xs text-brand-soft/70 mt-1">{b.pet_parent_name} · {b.whatsapp_number}</div>
    <div className="text-xs text-brand-maroon mt-1">in {b.days_until_next} day{b.days_until_next === 1 ? "" : "s"}</div>
  </div>
);
